import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/extractor-config')({
  staticData: { breadcrumb: 'Парсер событий' },
  component: () => <Outlet />,
});
